module.exports = __webpack_public_path__ + "assets/media/morning.1a8cdb6d.mp3";